import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  constructor(@Inject(PLATFORM_ID) public platformId,
    @Inject(DOCUMENT) public _doc: Document) {
  }

  getWindow(): Window | null {
    return this._doc.defaultView;
  }

  getLocation(): Location {
    return this._doc.location;
  }

  getLocalstorage(): any {
    return localStorage;
  }

  createElement(tag: string): HTMLElement {
    return this._doc.createElement(tag);
  }
}
